import React from 'react';
import SFIcon from '../SFIcon/SFIcon';
import classes from './EmptyState.module.css';

/**
 * Reusable empty state for list/table views.
 *
 * type="empty"    — no data exists at all (default)
 * type="filtered" — data exists but search/filter yields no results
 */
const EmptyState = ({ icon, heading, subtext, action, type = 'empty' }) => {
  const defaultIcon = type === 'filtered' ? 'emptySearch' : 'emptyFolder';
  const iconName = icon ?? defaultIcon;

  return (
    <div className={`${classes.container} ${type === 'filtered' ? classes.filtered : ''}`}>
      <SFIcon name={iconName} size={52} className={classes.icon} />
      <h4 className={classes.heading}>{heading}</h4>
      {subtext && <p className={classes.subtext}>{subtext}</p>}
      {action && (
        <button
          className="uk-button uk-button-danger uk-border-rounded"
          onClick={action.onClick}
          style={{ marginTop: '4px' }}
        >
          {action.label}
        </button>
      )}
    </div>
  );
};

export default EmptyState;
